/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import { types, applyPatch } from 'mobx-state-tree';

const CoreModelClass = require('gemini/lib/@waca/dashboard-common/dist/core/Model');

const model = new CoreModelClass(); //dont like creating model just to get the id generation

export function generateUniqueId(prefix) {
	return model._generateUniqueId(prefix);
}


export function adoptFunctions(coreModel, target, methodList, isBlocked, self) {
	const scope = self || target;
	for (var m in coreModel) {
		const shouldAdopt = isBlocked ? !methodList.includes(m) : methodList.includes(m);
		if(typeof coreModel[m] === 'function' && shouldAdopt ) {
			Object.defineProperty(target, m, {
				value: (coreModel[m]).bind(scope),
				writable: true
			});
		}
	}
}


export function setUsingPatch( model, name, value ) {
	const patch = {
		path: '/'+ name,
		op: 'replace',
		value: value
	};

	applyPatch(model, patch);
}


export function constructProps(attrs) {

	const props = {
		id: types.optional(types.identifier, generateUniqueId('model'))
	};

	const whitelistAttrs = attrs && attrs.whitelistAttrs || [];

	whitelistAttrs.forEach(function(value){
		props[value] = types.union( types.maybeNull(types.undefined),
			types.number,
			types.boolean,
			types.Date,
			types.string );
	});
	return props;
}



// WEBPACK FOOTER //
// ./src/js/core/utils.js